import { FC } from 'react';
import { PAIN_ZONES_LABELS } from '../../../enums/programming';

interface RtpPainZonesMapProps {
  painZones: Record<string, number>;
}

export const RtpPainZonesMap: FC<RtpPainZonesMapProps> = ({ painZones }) => {
  const entries = Object.entries(painZones).sort(([, a], [, b]) => b - a);
  const maxFreq = entries.length > 0 ? entries[0][1] : 1;

  if (entries.length === 0) {
    return <div style={{ padding: 16, textAlign: 'center', color: '#718096', fontSize: 13 }}>Nessuna zona dolore registrata.</div>;
  }

  // Body map as a grid of zones
  const getIntensityColor = (freq: number) => {
    const intensity = freq / maxFreq;
    if (intensity > 0.75) return '#E53E3E';
    if (intensity > 0.5) return '#ED8936';
    if (intensity > 0.25) return '#ECC94B';
    return '#F6E05E';
  };

  // Structured body regions
  const bodyRegions = [
    { label: 'Parte superiore', zones: ['spalla_dx', 'spalla_sx'] },
    { label: 'Tronco', zones: ['schiena_dorsale', 'schiena_lombare'] },
    { label: 'Anca / Inguine', zones: ['anca_dx', 'anca_sx', 'inguine_dx', 'inguine_sx'] },
    { label: 'Coscia', zones: ['quadricipite_dx', 'quadricipite_sx', 'hamstring_dx', 'hamstring_sx'] },
    { label: 'Ginocchio', zones: ['ginocchio_dx', 'ginocchio_sx'] },
    { label: 'Gamba', zones: ['polpaccio_dx', 'polpaccio_sx'] },
    { label: 'Piede', zones: ['piede_dx', 'piede_sx'] },
    { label: 'Altro', zones: ['altro'] },
  ];

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
      {bodyRegions.map((region) => {
        const regionZones = region.zones.filter((z) => painZones[z] != null);
        if (regionZones.length === 0) return null;
        return (
          <div key={region.label}>
            <div style={{ fontSize: 11, color: '#718096', marginBottom: 4 }}>{region.label}</div>
            <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
              {regionZones.map((zone) => {
                const freq = painZones[zone] || 0;
                const label = (PAIN_ZONES_LABELS as Record<string, string>)[zone] || zone;
                return (
                  <div
                    key={zone}
                    style={{
                      padding: '6px 10px',
                      borderRadius: 6,
                      backgroundColor: getIntensityColor(freq),
                      color: '#fff',
                      fontSize: 12,
                      fontWeight: 500,
                      display: 'flex',
                      alignItems: 'center',
                      gap: 4,
                    }}
                    title={`${label}: ${freq} occorrenze`}
                  >
                    {label}
                    <span style={{ fontSize: 10, opacity: 0.8 }}>({freq})</span>
                  </div>
                );
              })}
            </div>
          </div>
        );
      })}

      {/* Legend */}
      <div style={{ display: 'flex', gap: 12, marginTop: 8, fontSize: 11, color: '#718096' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
          <div style={{ width: 12, height: 12, borderRadius: 2, backgroundColor: '#E53E3E' }} />
          Alta freq.
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
          <div style={{ width: 12, height: 12, borderRadius: 2, backgroundColor: '#ED8936' }} />
          Media
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
          <div style={{ width: 12, height: 12, borderRadius: 2, backgroundColor: '#ECC94B' }} />
          Bassa
        </div>
      </div>
    </div>
  );
};

export default RtpPainZonesMap;
